import { render, staticRenderFns } from "./RequestError.vue?vue&type=template&id=0bc0bc53&scoped=true"
import script from "./RequestError.vue?vue&type=script&lang=js"
export * from "./RequestError.vue?vue&type=script&lang=js"
import style0 from "./RequestError.vue?vue&type=style&index=0&id=0bc0bc53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc0bc53",
  null
  
)

export default component.exports